import Service, { inject as service } from '@ember/service';
import Ember from 'ember';
import config from 'cio/config/environment';
import moment from 'moment-timezone';
import AccountService from './account';
import UserModel from 'cio/models/user';

export default class SatismeterService extends Service {
  @service account!: AccountService;

  register(user: UserModel) {
    if (!Ember.testing) {
      let { firstName, lastName } = user;
      let createdAt = moment.unix(user.createdAt).format();

      // always use currently loaded account:
      let account = this.account.current;
      let accountUsage = account.usage;

      window.satismeter?.({
        writeKey: config.satismeter.writeKey,
        userId: user.id,
        traits: {
          name: `${firstName} ${lastName}`,
          email: user.email,
          createdAt,
          accountId: account.id,
          accountName: account.name,
          accountEmail: account.email,
          accountState: account.accountState,
          planPrice: account.planPrice,
          verificationState: account.verificationState,
          customersTotal: accountUsage?.customersTotal,
          admin: account.admin,
          emailsSent: accountUsage?.billableMessagesSent,
          role: user.role,
        },
      });
    }
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    satismeter: SatismeterService;
  }
}
